import lightbox from '../../src/js/lightbox';

const videoButton = {
    /**
     * Initializes every video button inside root, or root itself when it is one.
     * Safe to call repeatedly: ACF replaces the preview DOM after every field change.
     */
    init: function( root, options = {} ) {
        const scope  = root || document;
        const blocks = [];

        if ( scope.matches && scope.matches('.video-button') ) {
            blocks.push( scope );
        }

        if ( scope.querySelectorAll ) {
            blocks.push( ...scope.querySelectorAll('.video-button') );
        }

        blocks.forEach( (block) => {
            block.querySelectorAll('.js-video-button').forEach( (playButton) => {
                this.showVideoInLightbox( playButton, block, options );
            });
        });
    },

    showVideoInLightbox: function( playButton, parentItem ) {

        if ( ! playButton || ! parentItem || playButton.dataset.videoButtonReady === 'true' ) {
            return;
        }

        playButton.dataset.videoButtonReady = 'true';

        lightbox.init( parentItem );

        playButton.addEventListener('click', (e) => {
            e.preventDefault();
            lightbox.open( parentItem, e );
        });
    }
}

export default videoButton;

// The editor boots this module through src/js/_editor.js instead.
if ( ! window.acf ) {
    if ( document.readyState === 'loading' ) {
        document.addEventListener('DOMContentLoaded', () => videoButton.init( document, { isEditor: false } ));
    } else {
        videoButton.init( document, { isEditor: false } );
    }
}
